import React, { HTMLProps, ReactNode, RefObject } from 'react'
import parse from 'html-react-parser'
import { WP_REST_API_Post } from 'wp-types/index'
import { twMerge } from 'tailwind-merge'
import ScrollBar from '../../../../components/ScrollBar'

interface ApplicationNoteDetailsProps extends HTMLProps<HTMLDivElement> {
  post: WP_REST_API_Post
  articleRef?: RefObject<HTMLDivElement>
  children: ReactNode
  classes?: {
    inner?: string
    outer?: string
    scroll?: string
  }
}

const ApplicationNoteDetails = ({
    post,
    articleRef,
    children,
    classes,
}: ApplicationNoteDetailsProps) => {
    return (
        <div className={twMerge('relative', classes?.outer)}>
            <div
                className={twMerge(
                    'overflow-y-scroll pr-4 md:pr-8 h-full no-scrollbar resource-body',
          classes?.inner,
                )}
                ref={articleRef}
            >
                {children}
                {parse(post.content.rendered)}
            </div>
            {articleRef && (
                <div className={twMerge('absolute top-0 right-0', classes?.scroll)}>
                    <ScrollBar
                        scrollRef={articleRef}
                        style={{ height: articleRef.current?.clientHeight ?? '100%' }}
                    />
                </div>
            )}
        </div>
    )
}

export default ApplicationNoteDetails
